module.exports = __webpack_public_path__ + "img/wb-cover.adf4b1b6.jpg";